export default __webpack_public_path__ + "static/media/link_w.f547cc5a.svg";